export const CONTENT_MANAGEMENT_REQUEST = 'CONTENT_MANAGEMENT_REQUEST';
export const CONTENT_MANAGEMENT_SUCCESS = 'CONTENT_MANAGEMENT_SUCCESS';
export const CONTENT_MANAGEMENT_FAIL = 'CONTENT_MANAGEMENT_FAIL';